var map = {
	"./android-user.png": "d0b6",
	"./footer-icon.png": "2008",
	"./footer-logo.png": "a277",
	"./gongzhong.png": "808b",
	"./ios-user.png": "38cb",
	"./kefu.png": "7596",
	"./weixin-user.png": "b810"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2641";